export const BASE_URL = "https://3.233.57.181:8080/";
export const READ_ALL_CATEGORY = "api/category/readAllCategories";
export const READ_ALL_PRODUCTS = "api/store/readAllStoreInventoryType?";
export const API_OFFER = "api/offer/getAllApiOffer";
export const CATEGORYOFFER = "api/offer/readAllOfferType?";
export const READ_ALL_BANNER_OFFERS = "api/offer/getAllBannerFilter";
export const ADD_TO_CART = "api/cart/createAddToCart";
export const REMOVE_FROM_CART = "api/cart/removeCartItem";
export const READ_CART_ITEMS = "api/cart/readOneOrdersQuntity?";
export const VALIDATE_PROMOCODE = "api/cart/validatePromocode";
export const CONTACT_ADD = "/api/contact/createContact";
export const VERIFY_EMAIL = "api/users/forgetPassword";
export const GET_ORDER_BY_ID = `/api/order/readOneOrderData`;
export const VERIFY_OTP = "api/users/readOneuserOtp";
export const UPDATE_PASSWORD = "api/users/updatePassword";
export const CREATE_ORDER = "/api/order/createOrder";
export const READ_ONE_USER = "/api/users/readOneUser?";
export const READ_ONE_EVENT = "/api/event/readOneEvents?event_id=";
export const READ_ALL_EVENTS = "/api/event/readAllEvents";
export const READ_ALL_ORDERS = "/api/order/readAllOrder?";
export const READ_ITEMS_FROM_CART = "/api/order/readOneOrderData?";
export const READ_ALL_OFFER = "/api/offer/getAllApiOffer";
export const READ_ALL_FAQ = "/api/faq/readAllFaqs";
export const READ_EVENT_THEME =
  "/api/websiteColorThemes/readOneEventColorThemes";
export const READ_DEFAULT_THEME =
  "/api/websiteColorThemes/readOneDefaultColorThemes";
export const READ_EVENT_HOWITWORKS = "/api/howItWork/eventIdHowItWork";
export const READ_HOWITWORKS = '/api/howItWork/readAllHowItWorks';
export const UPDATE_USER = "/api/users/updateUserEmail";
export const UPDATE_USER_WITH_USER_ROLE = "/api/users/updateUserEmailWithUserRole";
export const READ_ALL_NOTIFICATION = 'api/notification/readAllEventNotification';
export const READ_NESTED_CATEGORIES = "/api/category/readAllCategoriesData";
export const UPDATE_NOTIFICATION = "api/notification/updateIsReadNotification";
export const CREATE_INTERESTED = "/api/interested/createInterested"
export const READ_ALL_INTERESTED = "/api/Interested/readAllInterested"
export const DOWNLOAD_QR_CODE= "/api/order/downloadQrCode"
export const  RESEND_LINK = "/api/users/resendLinkVerification"
export const CATEGORIES_PARENTDATA= "/api/category/readCategoriesAllParent"